/* eslint-disable import/no-cycle */
import React from 'react';
import PropTypes from 'prop-types';
import AppText from '../../../../common/AppText';
import { getWebstoreHeadingSize } from '../../../../../helpers/webstoreHelper';

const WsHeadingBlock = ({ config }) => (
  <AppText
    style={{
      fontWeight: 900,
      fontSize: getWebstoreHeadingSize(config.headingSize),
      wordBreak: 'break-word',
      overflowWrap: 'break-word'
    }}
  >
    {config.text}
  </AppText>
);

WsHeadingBlock.propTypes = { config: PropTypes.object };

export default WsHeadingBlock;
